import React, { useRef, useEffect } from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";

const SearchInput = () => {
  const { searchTerm, setSearchTerm } = useApiDocsContext();
  const inputRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className="api-docs-search">
      <svg className="api-docs-search-icon" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
      </svg>
      <input
        ref={inputRef}
        type="text"
        className="api-docs-search-input"
        placeholder="Search endpoints... (⌘K)"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {searchTerm && (
        <button
          className="api-docs-search-clear"
          onClick={() => setSearchTerm("")}
          aria-label="Clear search"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default SearchInput;
